import React from "react";
import { ThemeMenu2 } from "../Theme2/Theme2";
import { useParams } from "react-router-dom";

const Theme2 = ({
  orgInfo,
  orgData,
  orgcode: propOrgcode,
  ads = [],
  isVideoPlaying,
  setIsVideoPlaying,
}) => {
  const { orgcode: paramOrgcode } = useParams();
  const orgcode = propOrgcode || paramOrgcode; // Use prop first, fallback to params
  return (
    <>
      {orgcode && (
        <ThemeMenu2
          orgInfo={orgInfo}
          orgData={orgData}
          ads={ads}
          isVideoPlaying={isVideoPlaying}
          setIsVideoPlaying={setIsVideoPlaying}
        />
      )}
    </>
  );
};

export { Theme2 };
